var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemtracker-module",
    attrs: {
      "data-test": "outside-vif"
    }
  }, [_vm.chemicalContainer ? _c('div', [_c('ChemicalContainerDetails', {
    attrs: {
      "chemical-container": _vm.chemicalContainer
    }
  }), _vm._v(" "), _c('SdsSearchResultsListing', {
    ref: "sdsSearchResults",
    attrs: {
      "sds-search-results": _vm.sdsSearchResults,
      "is-active": _vm.resultsListingActive
    },
    on: {
      "reset-sds-selection": _vm.resetSdsSelection
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action-items"
  }, [_c('p', [_vm._v("\n        Relevant SDS not listed above? Choose from options below to select a\n        new SDS for the chemical.\n      ")]), _vm._v(" "), _vm.hasErrors() ? _c('div', {
    staticClass: "messages error messages--error"
  }, [_c('b', [_vm._v("Please correct the following error(s):")]), _vm._v(" "), _c('ul', _vm._l(_vm.getErrors(), function (error) {
    return _c('li', [_vm._v("\n            " + _vm._s(error) + "\n          ")]);
  }), 0)]) : _vm._e(), _vm._v(" "), _c('b-form', {
    ref: "manualSdsAttachment",
    attrs: {
      "id": "chemtracker-sds-attachments-ui-manual"
    }
  }, [_c('b-radio-group', {
    on: {
      "change": function ($event) {
        return _vm.clearSelectedSdsDocumentId();
      }
    }
  }, [_c('b-form-radio', {
    staticClass: "form-group",
    attrs: {
      "value": "sds_file"
    },
    model: {
      value: _vm.selectedSdsOption,
      callback: function ($$v) {
        _vm.selectedSdsOption = $$v;
      },
      expression: "selectedSdsOption"
    }
  }, [_vm._v("\n            Upload SDS\n          ")]), _vm._v(" "), _vm.selectedSdsOption === 'sds_file' ? _c('div', {
    staticClass: "sds-manual-entry-wrapper"
  }, [_c('p', [_vm._v("\n              SDS uploaded here remains exclusively on your organization's\n              instance of ChemTracker, and are not automatically shared with a\n              centralized database. This SDS will be available to anyone who\n              may access containers of these chemicals or products\n            ")]), _vm._v(" "), _c('b-form-file', {
    ref: "file1",
    attrs: {
      "state": Boolean(_vm.file1),
      "accept": ".pdf",
      "size": "sm",
      "name": "sds_file",
      "required": "",
      "placeholder": "Allowed file extensions: pdf. 20mb file size limit."
    },
    model: {
      value: _vm.file1,
      callback: function ($$v) {
        _vm.file1 = $$v;
      },
      expression: "file1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n              Selected file: " + _vm._s(_vm.file1 ? _vm.file1.name : "") + "\n            ")]), _vm._v(" "), _c('b-row', [_c('b-col', [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "raftjs-entity-view-label",
    attrs: {
      "for": "sds-file-source"
    }
  }, [_vm._v("Source: "), _c('sup', [_vm._v("*")]), _c('b-img', {
    staticClass: "help-icon",
    attrs: {
      "id": "sds-file-source-help",
      "src": _vm.getHelpIconPath(),
      "alt": "help"
    }
  })], 1)]), _vm._v(" "), _c('b-popover', {
    attrs: {
      "target": "sds-file-source-help",
      "triggers": "hover focus"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(" SDS Source ")]), _vm._v("\n                  Please enter the manufacturer name or other name or title of\n                  where this URL came from, up to 255 characters (including\n                  spaces).\n                ")], 2), _vm._v(" "), _c('b-input', {
    class: {
      'is-invalid error': _vm.sdsEntityErrors.hasOwnProperty('sds-file-source')
    },
    attrs: {
      "type": "text",
      "name": "sds-file-source",
      "id": "sds-file-source",
      "aria-label": "Enter SDS source",
      "size": "sm",
      "maxlength": "255",
      "placeholder": "Enter the source for the SDS file"
    },
    model: {
      value: _vm.submittedSdsSource,
      callback: function ($$v) {
        _vm.submittedSdsSource = $$v;
      },
      expression: "submittedSdsSource"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "raftjs-entity-view-label",
    attrs: {
      "for": "file-sds-document-date"
    }
  }, [_vm._v("SDS Document Date: "), _c('sup', [_vm._v("*")])])]), _vm._v(" "), _c('SciSureDatePicker', {
    attrs: {
      "record-date": _vm.submittedSdsDocumentDate,
      "is-required": true,
      "is-max-date": true,
      "name": "file-sds-document-date",
      "id": "file-sds-document-date",
      "payload-type": "date"
    },
    on: {
      "update-record-date": _vm.updateDocumentDate
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-form-radio', {
    staticClass: "form-group",
    attrs: {
      "value": "sds_url"
    },
    model: {
      value: _vm.selectedSdsOption,
      callback: function ($$v) {
        _vm.selectedSdsOption = $$v;
      },
      expression: "selectedSdsOption"
    }
  }, [_vm._v("\n            Assign SDS as URL/link\n          ")]), _vm._v(" "), _vm.selectedSdsOption === 'sds_url' ? _c('div', {
    staticClass: "sds-manual-entry-wrapper"
  }, [_c('b-row', {
    class: {
      'is-invalid error': _vm.sdsEntityErrors.hasOwnProperty('sds-url-url')
    }
  }, [_c('b-col', [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "raftjs-entity-view-label",
    attrs: {
      "for": "sds-url-url"
    }
  }, [_vm._v("SDS URL: "), _c('sup', [_vm._v("*")])])]), _vm._v(" "), _c('b-input', {
    class: {
      'is-invalid error': _vm.sdsEntityErrors.hasOwnProperty('sds-url-url')
    },
    attrs: {
      "type": "url",
      "name": "sds-url-url",
      "id": "sds-url-url",
      "aria-label": "Enter SDS URL",
      "size": "sm",
      "placeholder": "Enter the URL for the SDS file"
    },
    model: {
      value: _vm.submittedSdsUrl,
      callback: function ($$v) {
        _vm.submittedSdsUrl = $$v;
      },
      expression: "submittedSdsUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    class: {
      'is-invalid error': _vm.sdsEntityErrors.hasOwnProperty('sds-url-title')
    }
  }, [_c('b-col', [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "raftjs-entity-view-label",
    attrs: {
      "for": "sds-url-title"
    }
  }, [_vm._v("Title: "), _c('sup', [_vm._v("*")]), _c('b-img', {
    staticClass: "help-icon",
    attrs: {
      "id": "sds-url-title-help",
      "src": _vm.getHelpIconPath(),
      "alt": "help"
    }
  })], 1)]), _vm._v(" "), _c('b-popover', {
    attrs: {
      "target": "sds-url-title-help",
      "triggers": "hover focus"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(" SDS Title ")]), _vm._v("\n                  Please enter a title or short description, up to 255\n                  characters (including spaces).\n                ")], 2), _vm._v(" "), _c('b-input', {
    class: {
      'is-invalid error': _vm.sdsEntityErrors.hasOwnProperty('sds-url-title')
    },
    attrs: {
      "type": "text",
      "required": "",
      "aria-required": "true",
      "id": "sds-url-title",
      "name": "sds-url-title",
      "aria-label": "Enter SDS title",
      "size": "sm",
      "maxlength": "255",
      "placeholder": "Enter the title for the SDS URL"
    },
    model: {
      value: _vm.submittedSdsTitle,
      callback: function ($$v) {
        _vm.submittedSdsTitle = $$v;
      },
      expression: "submittedSdsTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    class: {
      'is-invalid error': _vm.sdsEntityErrors.hasOwnProperty('sds-url-source')
    }
  }, [_c('b-col', [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "raftjs-entity-view-label",
    attrs: {
      "for": "sds-url-source"
    }
  }, [_vm._v("Source: "), _c('sup', [_vm._v("*")]), _c('b-img', {
    staticClass: "help-icon",
    attrs: {
      "id": "sds-url-source-help",
      "src": _vm.getHelpIconPath(),
      "alt": "help"
    }
  })], 1)]), _vm._v(" "), _c('b-popover', {
    attrs: {
      "target": "sds-url-source-help",
      "triggers": "hover focus"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(" SDS Source ")]), _vm._v("\n                  Please enter the manufacturer name or other name or title of\n                  where this URL came from, up to 255 characters (including\n                  spaces).\n                ")], 2), _vm._v(" "), _c('b-input', {
    class: {
      'is-invalid error': _vm.sdsEntityErrors.hasOwnProperty('sds-url-source')
    },
    attrs: {
      "type": "text",
      "name": "sds-url-source",
      "id": "sds-url-source",
      "aria-label": "Enter SDS source",
      "size": "sm",
      "maxlength": "255",
      "placeholder": "Enter the source for the SDS URL"
    },
    model: {
      value: _vm.submittedSdsSource,
      callback: function ($$v) {
        _vm.submittedSdsSource = $$v;
      },
      expression: "submittedSdsSource"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "raftjs-entity-view-label",
    attrs: {
      "for": "url-sds-document-date"
    }
  }, [_vm._v("SDS Document Date: "), _c('sup', [_vm._v("*")])])]), _vm._v(" "), _c('SciSureDatePicker', {
    attrs: {
      "record-date": _vm.submittedSdsDocumentDate,
      "is-required": true,
      "is-max-date": true,
      "name": "url-sds-document-date",
      "id": "url-sds-document-date",
      "payload-type": "date"
    },
    on: {
      "update-record-date": _vm.updateDocumentDate
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), !_vm.hideControls ? _c('div', {
    staticClass: "sds-attachments-dialog-controls"
  }, [_vm.allowAttach ? _c('button', {
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Attach SDS")]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _vm.hideControls ? _c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_vm.$isB4 ? _c('div', {
    staticClass: "loading-throbber"
  }, [_c('b-spinner', {
    staticClass: "align-middle"
  })], 1) : _c('div', [_c('img', {
    attrs: {
      "src": "/sites/all/modules/hide_submit/images/squares.gif",
      "alt": "loading"
    }
  })])]) : _vm._e()], 1) : _c('div', [_c('RaftBusy', {
    attrs: {
      "busy-text": "Loading..."
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }